// extracted by mini-css-extract-plugin
export default {"services_card_section":"ServicesCard_services_card_section__XRN3M","services_card_content_area":"ServicesCard_services_card_content_area__J-+PS"};